import React, {useState} from 'react';
import {useSelector} from 'react-redux';

import {
  checkinTime as checkinTimeSelectorFn,
  checkoutTime as checkoutTimeSelectorFn,
} from '../../selectors/index';
import {hotelPolicyDataSelector} from '../../../../pages/DetailsPage/selectors';

import {timeFormat} from '../../utils/details-page-utils';

import ArrowRight from '../../../../../stories/Icons/ArrowRightDetailIcon';
import RoundedCheckbox from '../../../../../stories/Icons/RoundedCheckbox';

import Modal, {useModal} from '../../../../components/Modal';
import BrandModalHeader from '../../../../components/BrandModalHeader';

import * as S from './HotelDetails.styles';
import { defaultTheme } from '@ibibo/build-theme';

export default function HotelDetails() {

  const [isHotelPolicyOpen, setIsHotelPolicyOpen] = useState(false);

  const checkInTime = useSelector(checkinTimeSelectorFn) || '';
  const checkoutTime = useSelector(checkoutTimeSelectorFn) || '';

  const checkInFormatted = timeFormat(checkInTime) || '';
  const checkOutFormatted = timeFormat(checkoutTime) || '';
  const {hotelPolicyList, hotelPolicyError, hotelPolicyFetchStatus} = useSelector(
    hotelPolicyDataSelector,
  );

  const openHotelPolicy = () => {
    setIsHotelPolicyOpen(true);
  }
  
  const closeHotelPolicy = () => {
    setIsHotelPolicyOpen(false);
  }

  const showPolicy = !!hotelPolicyList.length;

  return (
    <S.HotelPoliciesWrap>
      <S.RulesHeadWrap>
          <S.RulesHeadText>Rules & Policies</S.RulesHeadText>
          <S.CheckInOutWrap>
              <S.CheckWrap>
                  <S.CheckText>CHECK IN:</S.CheckText>
                  <S.CheckTimeText>{checkInFormatted}</S.CheckTimeText>
              </S.CheckWrap>
              <S.CheckWrap>
                  <S.CheckText>CHECK OUT:</S.CheckText>
                  <S.CheckTimeText>{checkOutFormatted}</S.CheckTimeText>
              </S.CheckWrap>
          </S.CheckInOutWrap>
      </S.RulesHeadWrap>

      <S.MandatoryTag>
        <S.MadatoryText>It is mandatory for all guests to give valid photo ID at the time of check-in</S.MadatoryText>
      </S.MandatoryTag>

      {(showPolicy && <S.PolicyWrap>
        <S.GeneralWrap>
          <S.GeneralText onClick={openHotelPolicy}>General Policy</S.GeneralText>
          <ArrowRight {...ArrowProps} />
        </S.GeneralWrap>
      </S.PolicyWrap>)}

      <Modal
        isOpen={isHotelPolicyOpen}
        closeModal={closeHotelPolicy}
        modalStyles={{width: 'auto', height: '70vh',  'border-radius': '4px'}}
      >
        <BrandModalHeader>Hotel Policy</BrandModalHeader>
        <S.PolicyListBlock>
          {hotelPolicyList.map((policy: string, i) => (
            <S.PolicyListItemTextStyled key={`policy${i}`}>
              <S.CheckedIconWrapperStyled>
                <RoundedCheckbox {...staticCheckedIconProps} />
              </S.CheckedIconWrapperStyled>

              <S.PolicyTextStyled>{policy}</S.PolicyTextStyled>
            </S.PolicyListItemTextStyled>
          ))}
        </S.PolicyListBlock>
      </Modal>
    </S.HotelPoliciesWrap>
  );
}

const staticCheckedIconProps = {
  height: '20px',
  fill: defaultTheme.colors.grey.grey75,
};

const ArrowProps = {
  width: defaultTheme.spacing.small.s9,
  height: defaultTheme.spacing.small.s9,
  fill: defaultTheme.colors.blue.base
}
